import stls from '@f_ucs/styles/components/actionPanel/actionButtonHandlers/createCollectorModal/CreateCollectorModal.module.sass';
import { Button } from '@mui/material';
import GeneralForm from '@f_general/GeneralForm';
import { t } from 'i18next';

export interface CollectorPartOfModalProps {
    sendDataHandler: (values: any) => Promise<void>;
    closeModal: () => void;
    mobile: boolean;
    loading: boolean;
}

export function CollectorPartOfModal({ sendDataHandler, closeModal, mobile, loading }: CollectorPartOfModalProps) {
    return (
        <GeneralForm
            sendDataHandler={sendDataHandler}
            close={closeModal}
            actions={
                <div className={stls.action} style={mobile ? {} : { display: 'flex' }}>
                    <Button className={stls.modalButton} onClick={closeModal}>
                        {t('modal.cancel')}
                    </Button>
                    <Button disabled={loading} className={stls.modalButton} variant={'contained'} type="submit">
                        {t('modal.success')}
                    </Button>
                </div>
            }
            mainData={{
                icon: '',
                title: '',
                props: [
                    {
                        title: 'Введите название отчета:',
                        control: 'input',
                        name: 'title',
                        type: 'text',
                        placeholder: 'Введите название конфигурации',
                        castomStyle: {
                            width: '325px',
                            '& .MuiInputBase-input': {
                                padding: '12px',
                            },
                        },
                    },
                    {
                        control: 'checkbox',
                        title: 'Выберите параметры отчета:',
                        name: 'sameWarehouse',
                        type: 'checkbox',
                        options: [
                            {
                                key: 'По складу',
                                value: false,
                                tooltip: 'В нарушения попадут только предложения с того же склада',
                            },
                        ],
                    },
                    {
                        control: 'checkbox',
                        title: '',
                        name: 'sameStatus',
                        type: 'checkbox',
                        options: [
                            {
                                key: 'По статусу',
                                value: false,
                                tooltip:
                                    'В нарушения попадут только предложения с тем же статусом или со статусом, содержащим «в наличии»',
                            },
                        ],
                    },
                    {
                        control: 'checkbox',
                        title: '',
                        name: 'sameQuantity',
                        type: 'checkbox',
                        options: [
                            {
                                key: 'По количеству',
                                value: false,
                                tooltip:
                                    'В нарушения попадут только предложения с достаточным количеством товара (не меньше требуемого)',
                            },
                        ],
                    },
                    {
                        control: 'checkbox',
                        title: '',
                        name: 'sameItem',
                        type: 'checkbox',
                        options: [
                            {
                                key: 'По совпадению артикула и бренда',
                                value: false,
                                tooltip: 'В нарушения попадут только предложения с тем же артикулом и брендом',
                            },
                        ],
                    },
                    {
                        control: 'checkbox',
                        title: '',
                        name: 'sameProbabilityDelivery',
                        type: 'checkbox',
                        options: [
                            {
                                key: 'По вероятности поставки',
                                value: false,
                                tooltip:
                                    'В нарушения попадут только предложения с вероятностью поставки не ниже, чем у заказанного товара',
                            },
                        ],
                    },
                    {
                        control: 'checkbox',
                        title: '',
                        name: 'sameReturnStatus',
                        type: 'checkbox',
                        options: [
                            {
                                key: 'По возвратности товара',
                                value: false,
                                tooltip: 'В нарушения попадут только предложения с тем же статусом возвратности',
                            },
                        ],
                    },
                    {
                        control: 'checkbox',
                        title: '',
                        name: 'sameDeliveryDateTodayOrEarly',
                        type: 'checkbox',
                        options: [
                            {
                                key: 'По сроку поставки',
                                value: false,
                                tooltip:
                                    'В нарушения попадут только предложения со сроком поставки не позже, чем у выбранного товара',
                            },
                        ],
                    },
                ],
                shema: null,
                type: 'editApp',
                data: {
                    title: '',
                    sameWarehouse: false,
                    sameStatus: false,
                    sameQuantity: false,
                    sameItem: false,
                    sameProbabilityDelivery: false,
                    sameReturnStatus: false,
                    sameDeliveryDateTodayOrEarly: false,
                    type: 'createReport',
                },
            }}
            loading={false}
        />
    );
}
